import { useCallback } from 'react';
import { useGlobalState, useGlobalDispatch } from '../stateProviders/GlobalStateProvider';

export const useSidebarToggle = () => {
	const globalState = useGlobalState();
	const globalDispatch = useGlobalDispatch();

	const toggleSidebar = useCallback(() => {
		globalDispatch({
			sidebarCollapsed: !globalState.sidebarCollapsed,
		});
	}, [globalState.sidebarCollapsed, globalDispatch]);

	return {
		isCollapsed: globalState.sidebarCollapsed,
		toggleSidebar,
	};
};
